<!--
  @description 意见反馈
  @author cjs1992
  @date 2020-08-21 08:43:30
-->
<template>
  <div class="app_container">
    <div class="mainContent topPart">
      <div class="headerAndNav">
        <v-header></v-header>
        <v-nav :index="null"></v-nav>
      </div>
    </div>
    <div class="yjfk_container">
      <div class="title_wrap">
        <span>意见反馈</span>
        <el-button
          style="float: right;margin-top: -6px;"
          type="primary"
          size="small"
          @click="showHistoryDialog"
        >历史反馈</el-button>
      </div>
      <!-- 内容区域 -->
      <div class="yjfk_content">
        <div class="fk_item">
          <div class="fk_item_name">
            <span class="need">*</span>
            反馈类型：
          </div>
          <div class="fk_item_content">
            <template v-for="(item, index) in problemTypeList">
              <div
                class="type_item"
                :key="index"
                :class="{
                  active: problemType === item.value
                }"
                @click="typeItemClick(item)"
              >{{item.name}}</div>
            </template>
          </div>
        </div>
        <!-- 您的反馈意见 -->
        <div class="fk_item">
          <div class="fk_item_name">
            <span class="need">*</span>
            您的反馈意见：
          </div>
          <div class="fk_item_content">
            <el-input
              v-model="problemDesc"
              type="textarea"
              :rows="10"
              placeholder="请输入反馈意见"
            ></el-input>
          </div>
        </div>
        <!-- 您的联系方式 -->
        <div class="fk_item tableBox">
          <div class="fk_item_name">
            <span class="need">*</span>
            您的联系方式：
          </div>
          <div class="fk_item_content">
            <el-input
              v-model="phone"
              type="text"
              placeholder="请输入手机号"
              style="width: 400px;"
            ></el-input>
          </div>
        </div>
        <!-- 附件 -->
        <div class="fk_item tableBox" v-if="fileShowFlag">
          <div class="fk_item_name">
            附件：
          </div>
          <div class="fk_item_content">
            <!-- accept=".jpg,.jpeg,.png,.mp4,.mov,.mkv,.doc,.docx,.rar,.xls,.xlsx,.pdf,.txt" -->
            <el-upload
              ref="upload_ref"
              class="upload-demo"
              :action="uploadUrl"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :before-remove="beforeRemove"
              :on-success="uploadSuccess"
              :before-upload="beforeUpload"
              multiple
              name="files"
              :with-credentials="true"
              :on-exceed="handleExceed"
              :file-list="fileList"
              accept="video/*,image/*,.doc,.docx,.xls,.xlsx,.pdf"
            >
              <el-button
                size="small"
                type="primary"
              >上传文件</el-button>
              <div
                slot="tip"
                class="el-upload__tip"
                style="display: inline;color: #999;"
              >（可上传多个附件，附件包括图片、视频、Word、Excel、Pdf这些常用的附件类型，限制最大50M）</div>
            </el-upload>
          </div>
        </div>
        <!-- 关联事项 -->
        <div class="fk_item tableBox">
          <div class="fk_item_name">
            关联事项：
          </div>
          <div class="fk_item_content">
            <SelectMatter
              v-model="guidelineId"
              style="width: 400px;"
            ></SelectMatter>
          </div>
        </div>
        <!-- 是否需要回复 -->
        <div class="fk_item tableBox" v-if="problemReplyFlag">
          <div class="fk_item_name">
            是否需要回复：
          </div>
          <div class="fk_item_content special_switch_wrap">
            <el-switch
              v-model="needReply"
              active-text="是"
              inactive-text="否"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
            <span style="color: #999;">（请点击右上角历史反馈按钮查询历史咨询内容及回复结果）</span>
          </div>
        </div>

      </div>
      <!-- 下方按钮 -->
      <div class="btn_wrap">
        <el-button
          type="primary"
          style="width: 200px;"
          @click="submitFunc"
        >提交反馈信息</el-button>
        <el-button
          style="width: 200px;"
          @click="$router.go(-1)"
        >返回上一页</el-button>
      </div>
    </div>
    <div class="footer_wrap">
      <v-footer :hasInfo="1"></v-footer>
    </div>
    <v-toolBar></v-toolBar>
    <!-- 历史反馈的弹出层 -->
    <el-dialog
      title="历史反馈"
      width="1200px"
      :visible.sync="dialogVisible"
    >
      <div>
        <el-form
          :model="searchData"
          label-position="right"
          label-width="120px"
          class="search_form_wrap"
        >
          <el-form-item label="反馈类型">
            <el-select
              v-model="searchData.problemType"
              placeholder="请选择"
              size="small"
            >
              <el-option
                label="全部"
                value=""
              ></el-option>
              <template v-for="(item, index) in problemTypeList">
                <el-option
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="是否需要回复" v-if="problemReplyFlag">
            <el-select
              v-model="searchData.needReply"
              placeholder="请选择"
              size="small"
            >
              <el-option
                label="全部"
                value=""
              ></el-option>
              <el-option
                label="是"
                :value="1"
              ></el-option>
              <el-option
                label="否"
                :value="0"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="反馈时间">
            <el-date-picker
              v-model="searchData.startTime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              size="small"
              :editable="false"
              clearable
            >
            </el-date-picker>
            <span class="date_seprate_wrap">至</span>
            <el-date-picker
              v-model="searchData.endTime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              size="small"
              :editable="false"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="关联事项">
            <SelectMatter
              size="small"
              v-model="searchData.guidelineId"
            ></SelectMatter>
          </el-form-item>
          <el-form-item label="回复状态" v-if="problemReplyFlag">
            <el-select
              v-model="searchData.replyStatus"
              placeholder="请选择"
              size="small"
            >
              <el-option
                label="全部"
                value=""
              ></el-option>
              <el-option
                label="已回复"
                :value="1"
              ></el-option>
              <el-option
                label="未回复"
                :value="0"
              ></el-option>
              <el-option
                label="无需回复"
                :value="-1"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label-width="0"
            class="search_btn_wrap"
          >
            <el-button
              type="primary"
              @click="searchFunc"
              size="small"
              class="searchBtn"
            >查询</el-button>
            <el-button
              @click="resetFunc"
              class="resetBtn"
              size="small"
            >重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <Table
          :hasCheck="false"
          :theadData="theadData"
          :tableData="tableData"
          :isOneLine="true"
          border
        >
          <template v-slot:ope="{ scope }">
            <el-button
              type="primary"
              round
              size="mini"
              @click="seeItemFunc(scope.row)"
            >详情</el-button>
          </template>
        </Table>
        <div
          class="page_box"
          v-show="totalSize"
          style="text-align: center;margin-top: 10px;"
        >
          <el-pagination
            background
            :current-page="currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalSize"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
    <!-- 查看详情 -->
    <el-dialog
      title="详情"
      width="600px"
      :visible.sync="dialogVisible_see"
    >
      <el-form
        label-width="80px"
        v-loading="detailLoading"
        class="detail_form_wrap"
      >
        <el-form-item label="反馈类型">
          <span>{{rowData.problemType}}</span>
        </el-form-item>
        <el-form-item label="反馈内容">
          <span>{{rowData.problemDesc}}</span>
        </el-form-item>
        <el-form-item label="关联事项">
          <span>{{rowData.guidelineName || '-'}}</span>
        </el-form-item>
        <el-form-item label="附件" v-if="fileShowFlag">
          <template v-for="(item, index) in rowData.fileList">
            <div :key="index">
              <a :href="item.fileUrl | downloadFile(item.fileName)">{{item.fileName}}</a>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="反馈时间" class="width50">
          <span>{{rowData.opinionTime}}</span>
        </el-form-item>
        <el-form-item label="反馈人" class="width50">
          <span>{{rowData.userName}}</span>
        </el-form-item>
        <el-form-item label="联系方式">
          <span>{{rowData.phone}}</span>
        </el-form-item>
        <el-form-item label="回复状态" v-if="problemReplyFlag" class="width50">
          <span>{{rowData.replyStatus}}</span>
        </el-form-item>
        <el-form-item label="回复人" v-if="problemReplyFlag && rowData.replyStatus === '已回复'" class="width50">
          <span>{{rowData.replyUserName}}</span>
        </el-form-item>
        <el-form-item label="回复时间" v-if="problemReplyFlag && rowData.replyStatus === '已回复'" class="width50">
          <span>{{rowData.replyTime}}</span>
        </el-form-item>
        <el-form-item label="回复内容" v-if="problemReplyFlag && rowData.replyStatus === '已回复'">
          <span>{{rowData.replayDesc}}</span>
        </el-form-item>
      </el-form>
      <div style="text-align: center;margin: 20px 0 10px;">
        <el-button @click="dialogVisible_see = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Footer from "../common/Footer";
import Header from "../common/Header";
import TopNav from "../common/TopNav";
import ToolBar from "../common/ToolBar";
// 引入模糊查询事项的组件
import SelectMatter from "./select-matter.vue";
import { addProblem, getProblemList, getProblemById, configList } from "@/api/feedBack.js";
import Table from "@/components/table/table.vue";
export default {
  components: {
    "v-footer": Footer,
    "v-header": Header,
    "v-nav": TopNav,
    "v-toolBar": ToolBar,
    SelectMatter,
    Table
  },
  data() {
    return {
      // 反馈类型
      problemType: 1,
      // 反馈类型列表
      problemTypeList: [
        { name: "产品建议", value: 1 },
        { name: "功能异常", value: 2 },
        { name: "办事建议", value: 3 },
        { name: "其他建议", value: 4 }
      ],
      // 上传地址
      uploadUrl: "/portal-ywtb/public/uploadFiles",
      // 上传文件列表
      fileList: [],
      // 关联事项
      guidelineId: "",
      // 是否需要回复
      needReply: 0,
      // 反馈意见
      problemDesc: "",
      // 联系方式
      phone: "",
      // 历史反馈弹出层
      dialogVisible: false,
      // searchData
      searchData: {
        // 反馈类型
        problemType: "",
        // 是否需要回复
        needReply: "",
        // 回复时间-开始
        startTime: "",
        // 回复时间-结束
        endTime: "",
        // 关联事项id
        guidelineId: "",
        // 回复状态
        replyStatus: ""
      },
      oldSearchData: {
        // 反馈类型
        problemType: "",
        // 是否需要回复
        needReply: "",
        // 回复时间-开始
        startTime: "",
        // 回复时间-结束
        endTime: "",
        // 关联事项id
        guidelineId: "",
        // 回复状态
        replyStatus: ""
      },
      initSearchData: {
        // 反馈类型
        problemType: "",
        // 是否需要回复
        needReply: "",
        // 回复时间-开始
        startTime: "",
        // 回复时间-结束
        endTime: "",
        // 关联事项id
        guidelineId: "",
        // 回复状态
        replyStatus: ""
      },
      currentPage: 1,
      pageSize: 10,
      totalSize: 0,
      tableData: [],
      rowData: {},
      dialogVisible_see: false,
      loading: null,
      detailLoading: false,
      // 附件上传开关
      fileShowFlag: false,
      problemReplyFlag: false
    };
  },
  computed: {
    theadData() {
      let list = [
        { name: "序号", code: "index", width: 60 },
        { name: "反馈类型", code: "problemType", width: 80 },
        // { name: "是否需要回复", code: "needReplyName", width: 120 },
        // { name: "回复状态", code: "replyStatus", width: 80 },
        { name: "反馈时间", code: "opinionTime", width: 140 },
        { name: "关联事项", code: "guidelineName" },
        { name: "反馈内容", code: "problemDesc" },
        { name: "操作", code: "ope", slotName: "ope", width: 80 }
      ];
      if (this.problemReplyFlag === true) {
        list = [
          { name: "序号", code: "index", width: 60 },
          { name: "反馈类型", code: "problemType", width: 80 },
          // { name: "是否需要回复", code: "needReplyName", width: 120 },
          { name: "回复状态", code: "replyStatus", width: 80 },
          { name: "反馈时间", code: "opinionTime", width: 140 },
          { name: "关联事项", code: "guidelineName" },
          { name: "反馈内容", code: "problemDesc" },
          { name: "操作", code: "ope", slotName: "ope", width: 80 }
        ];
      }
      return list;
    }
  },
  filters: {
    downloadFile(path, name) {
      if (path.startsWith("http")) {
        return path;
      }
      return (
        "/portal-ywtb/public/downloadFile?fileName=" +
        encodeURIComponent(path) +
        "&realFileName=" +
        name
      );
    }
  },
  mounted() {
    this.configList();
  },
  methods: {
    /**
     * @name configList
     * @description 获取意见反馈配置
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-24 11:11:05
     */
    async configList() {
      if (!this.$store.state.isLogin) {
        // 回到登录页
        top.window.location = '/portal-ywtb/web/login?url=' + location.href;
        return;
      }
      const res = await configList();
      const list = res.data || [];
      for(let item of list) {
        if (item.moduleKey === "problem" && item.status !== 1) {
          // 回到首页
          this.$router.replace({
            path: "/"
          });
          return;
        }
        if (item.moduleKey === "problem_file") {
          this.fileShowFlag = item.status === 1 ? true : false;
        }
        if (item.moduleKey === "problem_reply") {
          this.problemReplyFlag = item.status === 1 ? true : false;
        }
      }
    },
    /**
     * @name seeItemFunc
     * @description 查看反馈信息
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-21 17:09:02
     */
    async seeItemFunc(param) {
      this.rowData = {};
      this.dialogVisible_see = true;
      this.detailLoading = true;
      let res = null;
      try {
        res = await getProblemById({
          id: param.id
        });
      } catch (error) {
        this.detailLoading = false;
        return;
      }
      this.detailLoading = false;
      this.rowData = res.data || {};
    },
    /**
     * @name showHistoryDialog
     * @description 点击历史反馈
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-21 16:48:36
     */
    showHistoryDialog() {
      this.dialogVisible = true;
      if (this.tableData.length === 0) {
        // 为空，请求
        this.handleCurrentChange(this.currentPage);
      }
    },
    /**
     * @name getProblemList
     * @description 获取反馈问题列表
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-21 16:51:03
     */
    async getProblemList() {
      const res = await getProblemList(this.searchData);
      let list = res.data.list || [];
      list.map((item, index) => {
        item.needReplyName = item.needReply ? "是" : "否";
        item.index = this.pageSize * (this.currentPage - 1) + index + 1;
      });
      this.tableData = list;
      this.totalSize = res.data.total;
    },
    /**
     * @name searchFunc
     * @description 搜索方法
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-21 16:48:54
     */
    searchFunc() {
      const { startTime, endTime } = this.searchData;
      const isEmpty = this.isEmpty;
      // eslint-disable-next-line no-self-compare
      if (
        !isEmpty(startTime) &&
        !isEmpty(endTime) &&
        new Date(startTime) > new Date(endTime)
      ) {
        this.$message({
          type: "warning",
          message: "开始时间不能大于结束时间"
        });
        return;
      }
      this.oldSearchData = {
        ...this.searchData
      };
      this.handleCurrentChange(1);
    },
    /**
     * @name isEmpty
     * @description null、undefined、空字符串、空数组、空对象
     * @param {}
     * @return Boolean
     * @author cjs1992
     * @date 2020-08-20 09:26:06
     */
    isEmpty(param) {
      if ([null, undefined, ""].indexOf(param) > -1) {
        return true;
      }
      const str = Object.prototype.toString.call(param).slice(8, -1);
      if (str === "Array" && param.length === 0) {
        // 数组
        return true;
      }
      if (str === "Object" && Object.keys(param).length === 0) {
        return true;
      }
      return false;
    },
    /**
     * @name resetFunc
     * @description 重置方法
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-21 16:49:08
     */
    resetFunc() {
      this.searchData = {
        ...this.initSearchData
      };
      this.searchFunc(1);
    },
    /**
     * @name handleCurrentChange
     * @description 切换页码
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-21 16:49:51
     */
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getProblemList();
    },
    /**
     * @name handleSizeChange
     * @description 切换每页展示条数
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-21 16:50:24
     */
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleCurrentChange(1);
    },
    /**
     * @name submitFunc
     * @description 提交反馈信息
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-21 16:09:23
     */
    async submitFunc() {
      let { problemDesc, phone } = this;
      if ([null, undefined].indexOf(problemDesc) > -1) {
        problemDesc = "";
      }
      problemDesc = String(problemDesc).trim();
      phone = String(phone).trim();
      if (problemDesc === "") {
        this.$message({
          type: "warning",
          message: "反馈意见不能为空"
        });
        return;
      }
      if (problemDesc.length > 1000) {
        this.$message({
          type: "warning",
          message: "反馈意见不能超出1000个字符"
        });
        return;
      }
      if (phone === "") {
        this.$message({
          type: "warning",
          message: "联系方式不能为空"
        });
        return;
      }
      const reg = /^(11|12|13|14|15|16|17|18|19)[0-9]{9}$/;
      if (!reg.test(phone)) {
        this.$message({
          type: "warning",
          message: "请输入正确的手机号"
        });
        return;
      }
      let fileList = this.fileList;
      fileList = fileList.map((item) => {
        return {
          fileName: item.name,
          fileUrl: Object.keys(item.response.data)[0]
        };
      });
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      try {
        await addProblem({
          problemType: this.problemType,
          guidelineId: this.guidelineId,
          needReply: this.needReply,
          phone,
          problemDesc,
          fileList
        });
      } catch (error) {
        this.loading.close();
        return;
      }
      this.loading.close();
      this.$message({
        type: "success",
        message: "反馈信息提交成功"
      });
      this.problemDesc = "";
      this.phone = "";
      this.guidelineId = "";
      this.$refs.upload_ref.clearFiles();
      // 重置查看列表的数据
      this.tableData = [];
      this.totalSize = 0;
      this.searchData = {
        ...this.initSearchData
      };
      this.oldSearchData = {
        ...this.initSearchData
      };
      this.currentPage = 1;
    },
    /**
     * @name typeItemClick
     * @description 反馈类型切换
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-21 14:41:40
     */
    typeItemClick(param) {
      this.problemType = param.value;
    },
    /**
     * @name uploadSuccess
     * @description 上传成功
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-21 15:41:54
     */
    uploadSuccess(res, file, fileList) {
      if (res.status === 200) {
        // 上传成功
        // const obj = res.data;
        // for (let key in obj) {
        //   file.name = obj[key];
        // }
        // this.fileList.push({})
        this.fileList = fileList;
      }
    },
    /**
     * @name beforeUpload
     * @description 上传之前的钩子
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-08-21 16:01:31
     */
    beforeUpload(file) {
      const {
        size,
        name
      } = file;
      if (size > 1024 * 1024 * 50) {
        // return new Error(`${name} 大于50M，无法上传`);
        this.$message({
          type: "warning",
          message: `${name} 大于50M，无法上传`
        });
        return false
      }
      return true;
      // console.log(file);
      // return Promise.reject();
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      this.fileList = fileList;
    },
    handlePreview(file) {
      // console.log(file);
    },
    handleExceed(files, fileList) {
      // this.$message.warning(
      //   `当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
      //     files.length + fileList.length
      //   } 个文件`
      // );
    },
    beforeRemove(file, fileList) {
      if (file && file.status === "ready") {
        return true;
      }
      return this.$confirm(`确定移除 ${file.name}？`);
    }
  }
};
</script>
<style lang="scss" scoped>
.width50 {
  display: inline-block;
  width: 49%;
  vertical-align: top;
}
.yjfk_container {
  background-color: #fff;
  width: 1200px;
  padding: 20px;
  margin: 10px auto 0;
  border-radius: 8px;
  .title_wrap {
    font-weight: 700;
    font-style: normal;
    font-size: 16px;
    text-align: left;
    border-bottom: 2px solid #f1f2f3;
    padding-bottom: 14px;
  }
  .fk_item {
    padding: 10px 0;
    .fk_item_name {
      font-weight: 700;
      font-style: normal;
      color: #333;
      font-size: 18px;
      height: 40px;
      line-height: 40px;
      span.need {
        color: #f00;
      }
    }

    /* 反馈类型 */
    .fk_item_content {
      .type_item {
        display: inline-block;
        width: 170px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background-color: rgba(242, 242, 242, 1);
        color: #666;
        margin-right: 10px;
        cursor: pointer;
        &:last-child {
          margin-right: 0;
        }
        &.active {
          background-color: rgba(33, 150, 243, 1);
          color: #fff;
        }
      }
    }

    &.tableBox {
      display: table;
      .fk_item_name {
        display: table-cell;
        width: 146px;
        text-align: right;
      }
      .fk_item_content {
        display: table-cell;
      }
    }
  }
}
.detail_form_wrap /deep/ {
  .el-form-item {
    margin-bottom: 0;
  }
}
.search_form_wrap /deep/ {
  .el-form-item {
    min-width: 280px;
    display: inline-block;
    vertical-align: top;
    margin-bottom: 10px;
    .el-select {
      width: 180px;
    }
    .el-input {
      width: 180px;
    }
    &.search_btn_wrap {
      min-width: auto;
      padding: 0 0 0 10px;
    }
    .date_seprate_wrap {
      padding: 0 4px;
    }
  }
}
.special_switch_wrap {
  // position: absolute;
  // right: 16px;
  // top: 12px;
  position: relative;
  height: 24px;
  /deep/ .el-switch {
    .el-switch__core {
      width: 56px !important;
      height: 20px;
      // border: 2px solid #fff;
      border-radius: 20px;
      &:after {
        top: 2px;
        left: 3px;
        width: 14px;
        height: 14px;
      }
    }
    &.is-checked {
      .el-switch__core {
        &:after {
          left: 100%;
          margin-left: -19px;
        }
      }
    }
  }
  /deep/ .el-switch__label * {
    font-size: 12px;
  }
  /deep/ .el-switch__label--left,
  /deep/ .el-switch__label--right {
    position: absolute;
    color: #fff;
    z-index: -1111;
    width: 40px;
    top: 0;
  }
  /deep/ .el-switch__label--left {
    left: 25px;
    text-align: left;
  }
  /deep/ .el-switch__label--right {
    right: 25px;
    text-align: right;
  }
  /deep/ .el-switch__label--right.is-active,
  /deep/ .el-switch__label--left.is-active {
    z-index: 1111;
    color: #fff !important;
  }
}
</style>
<style lang="scss" scoped>
.app_container {
  min-height: 100vh;
  padding-bottom: 291px;
  /* background-color: rgba(242, 242, 242, 1); */
  background-color: #f1f2f3;
  position: relative;
}
.footer_wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/yjfk/index.vue